module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/eu.530a3df4.svg";